import { styled } from "@mui/material";

export const Hints = styled("div")({ display: "flex" });

export const HINT_STYLES = { marginRight: "8px" };
